export default __webpack_public_path__ + "static/media/home-restaurant-img-21.09b2e9c6.jpg";